var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07331 0.238281L3.6931 0.526833V4.73707L5.36151 4.22571C5.7845 4.09606 6.07331 3.70548 6.07331 3.26306V0.238281ZM1.35135 0.806812C0.876886 0.863137 0.519531 1.26542 0.519531 1.74322V7.01866L2.25633 6.50786C2.68483 6.38183 2.97908 5.98857 2.97908 5.54192V0.613579L1.35135 0.806812Z",
    fill: "url(#paint0_linear_4472_63905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03265 9.62891L6.41286 9.34035V5.13012L4.74445 5.64148C4.32146 5.77113 4.03265 6.16171 4.03265 6.60413V9.62891ZM8.75461 9.06038C9.22907 9.00405 9.58643 8.60176 9.58643 8.12397V2.84852L7.84963 3.35933C7.42113 3.48536 7.12688 3.87862 7.12688 4.32527V9.25361L8.75461 9.06038Z",
    fill: "url(#paint1_linear_4472_63905)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03265 9.62891L6.41286 9.34035V5.13012L4.74445 5.64148C4.32146 5.77113 4.03265 6.16171 4.03265 6.60413V9.62891ZM8.75461 9.06038C9.22907 9.00405 9.58643 8.60176 9.58643 8.12397V2.84852L7.84963 3.35933C7.42113 3.48536 7.12688 3.87862 7.12688 4.32527V9.25361L8.75461 9.06038Z",
    fill: "url(#paint2_linear_4472_63905)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03265 9.62891L6.41286 9.34035V5.13012L4.74445 5.64148C4.32146 5.77113 4.03265 6.16171 4.03265 6.60413V9.62891ZM8.75461 9.06038C9.22907 9.00405 9.58643 8.60176 9.58643 8.12397V2.84852L7.84963 3.35933C7.42113 3.48536 7.12688 3.87862 7.12688 4.32527V9.25361L8.75461 9.06038Z",
    fill: "#DDEFEF",
    fillOpacity: 0.53
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4472_63905",
    x1: 0.519531,
    y1: 6.0525,
    x2: 14.8774,
    y2: -2.22099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4472_63905",
    x1: 2.20976,
    y1: 9.62572,
    x2: 22.8527,
    y2: 1.47892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4472_63905",
    x1: 9.58643,
    y1: 3.81469,
    x2: -4.77148,
    y2: 12.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvxIcon);
export default __webpack_public_path__ + "static/media/pvx-icon.61b63cc1121d3ef0caf5354683b2afed.svg";
export { ForwardRef as ReactComponent };